/** All known notification workflow keys (source.key from Knock)
 * AUTO-GENERATED - Do not edit manually.
 * Run `pnpm generate:workflow-keys` to regenerate.
 */
export const NOTIFICATION_WORKFLOW_KEYS = {
    CI_TEST: "ci-test",
    EXPORT_READY: "export-ready",
    LEASE_AUDIT_CHECK_OVERRIDE_REQUEST_RESOLUTION: "lease-audit-check-override-request-resolution",
    LEASE_AUDIT_HOTSPOTS: "lease-audit-hotspots",
    LEASE_AUDIT_NOTE_CREATED: "lease-audit-note-created",
    LEASE_AUDIT_OVERRIDE: "lease-audit-override",
    LEASE_AUDIT_SYSTEM_OVERRIDE: "lease-audit-system-override",
    NEW_TENANT: "new-tenant",
    NEW_USER: "new-user",
    NOTE_CREATED: "note-created",
    ONBOARDING_EXISTING_USER_EMAIL_1_INCREASING_YOUR_SUPERPOWERS: "onboarding-existing-user-email-1-increasing-your-superpowers",
    ONBOARDING_NEW_USER_EMAIL_1: "onboarding-new-user-email-1",
    ONBOARDING_NEW_USER_EMAIL_2: "onboarding-new-user-email-2",
    ONBOARDING_NEW_USER_EMAIL_3: "onboarding-new-user-email-3",
    ONBOARDING_NEW_USER_EMAIL_4: "onboarding-new-user-email-4",
    ONBOARDING_NEW_USER_EMAIL_5: "onboarding-new-user-email-5",
    PROPERTY_OPEN_LEASE_AUDIT_TASKS_WORKFLOW: "property-open-lease-audit-tasks-workflow",
    YOUR_OPEN_LEASE_AUDIT_OVERRIDE_REQUESTS: "your-open-lease-audit-override-requests",
    YOUR_OPEN_LEASE_AUDIT_TASKS_WORKFLOW: "your-open-lease-audit-tasks-workflow",
    YOUR_TEAMS_OPEN_LEASE_AUDIT_TASKS_WORKFLOW: "your-teams-open-lease-audit-tasks-workflow",
};
